import Table from 'react-bootstrap/Table';
import React, { useRef, useCallback} from 'react';

import "./basicTable.css";


const StickyHeadTable = ({ columns, dataList, handleLoadMore, isPagination=false, isInnertable=false, highlightList=[], onClickDetail }) => {

  const observer = useRef();
  var hideColumnsSmallScreen = [];

  columns.map((data, index) => {
    if (data.hideOnSmallScreen) {
      hideColumnsSmallScreen.push(index + 1);
    }
  });

  const lastTableElementRef = useCallback(node => {
    if (isPagination){
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          handleLoadMore();
        }
      })
      if (node) observer.current.observe(node);
    }
  }, [handleLoadMore]);

  return (
    <div className={isInnertable ? 'basic-table-div-inner-table' : 'basic-table-div'}>
      <Table className="basic-table-main" responsive>
            <thead>
          <tr>
            {
              columns.map((data, index) => {
                return <th className={data.hideOnSmallScreen ? 'd-none d-sm-table-cell': ""} key={index}>{data.label}</th>
              })
            }  
          </tr>    
        </thead>
        <tbody>
          {
            dataList.map((data, dataIndex) => {
              
              return (
                <tr
                  key={data[0]}
                  ref={dataList.length === dataIndex + 1 ? lastTableElementRef : null}
                  className={highlightList.indexOf(data[0]) > -1 ? 'basic-table-row basic-table-highlight-row': "basic-table-row"}
                >
                  <td
                    className={hideColumnsSmallScreen.indexOf(0) > -1 ? "basic-table-name d-none d-sm-table-cell" : "basic-table-name"}
                    onClick={() => onClickDetail(data[0])}
                  >
                    {data[1]}
                  </td>
                  {
                    data.map((column, index) => {
                      return (
                        index > 1
                          &&
                          <td key={index} className={hideColumnsSmallScreen.indexOf(index) > -1 ? "basic-table-other-column d-none d-sm-table-cell" : "basic-table-other-column"}>
                            {column}
                          </td>
                      );
                      
                    })
                  }
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    </div>
  );
}

export default StickyHeadTable;
